// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"aa638f30","453":"d23f1e8a"}[chunkId] + ".chunk.js";
};